import type { NationalIdRules } from '../types';

const digitsOnly = (value: string): string => value.replace(/\D/g, '');

/**
 * Argentine DNI: 7–8 digits (personal ID).
 * CUIL/CUIT is a separate fiscal identifier and is not validated here.
 */
const validateArgentineDni = (value: string): boolean => {
  const digits = digitsOnly(value);
  return /^\d{7,8}$/.test(digits);
};

const normalizeArgentineDni = (value: string): string => digitsOnly(value);

const formatArgentineDni = (value: string): string => {
  const digits = digitsOnly(value);
  if (!digits) {
    return '';
  }
  if (digits.length <= 2) {
    return digits;
  }
  if (digits.length <= 5) {
    return `${digits.slice(0, digits.length - 3)}.${digits.slice(-3)}`;
  }
  return `${digits.slice(0, digits.length - 6)}.${digits.slice(-6, -3)}.${digits.slice(-3)}`;
};

export const argentinaNationalId: NationalIdRules = {
  countryCode: 'AR',
  documentKind: 'DNI',
  labelKey: 'country.argentina.idCard',
  invalidKey: 'country.argentina.idCard.invalid',
  placeholder: '12.345.678',
  normalize: normalizeArgentineDni,
  format: formatArgentineDni,
  validate: validateArgentineDni,
  searchToken: (value: string) => digitsOnly(value),
};
